import React from 'react';
import ResumenDatosSeguro from 'components/APIndividual/ResumenDatosSeguro';

const DetalleValores = ({ datosTarifacion, codProducto }) => {
  return (
    <div className="col-12 col-lg-6 order-0 order-lg-1 align-self-center">
      <div className="m-2 m-md-4 m-xl-5">
        <ResumenDatosSeguro datosTarifacion={datosTarifacion} codProducto={codProducto} />
      </div>
    </div>
  );
};

export default DetalleValores;
